import { call, put, select, takeLatest, all, delay } from 'redux-saga/effects';
import Action from '../action';
import InvoiceApi from '../../Api/inoviceApi';
import { setSnackBar, setDialog, movePage } from './Common';
import taker from './taker';

/**
 * [Management] 거래처 리스트 조회
 */
export function* getClientList({ payload }) {
  const tin = payload.tin;

  const branchCode = payload.branchCode;
  const regex = /[^0-9]/g; // 숫자가 아닌 문자열을 선택하는 정규식

  payload = {
    ...payload,
    tin: tin.replace(regex, ''),
    branchCode: branchCode ? branchCode.replace(regex, '') : '',
  };

  const response = yield call(InvoiceApi.getClientList, payload);
  let clientList;
  if (response.status === 200) {
    clientList = response.data;
    yield put(Action.getClientList.success(clientList));
  }
}

/**
 * [Management] 거래처 선택(selected) 리스트 변경
 */
export function* setClientList({ payload }) {
  yield put(Action.setClientList.success(payload));
}

/**
 * [Management] 거래처 리스트 추가
 */
export function* insertClientList({ payload }) {
  // //tradeName 중복 체크 로직
  payload = {
    ...payload,
    tradeRegisteredName: payload.tradeRegisteredName.trim(),
  };

  // yield call(tradeRegisteredNameCheck, {
  //   tradeRegisteredName: payload.tradeRegisteredName,
  // });

  // let isTradeRegisteredName = yield select(
  //   (state) => state.reducer.checkElement.isTradeRegisteredName
  // );

  // if (isTradeRegisteredName) {
  //   return;
  // }

  const tin = payload.tin;
  const branchCode = payload.branchCode;
  const regex = /[^0-9]/g; // 숫자가 아닌 문자열을 선택하는 정규식

  payload = {
    ...payload,
    tin: tin.replace(regex, ''),
    branchCode: branchCode.replace(regex, ''),
  };

  let response = yield call(InvoiceApi.insertClientList, [payload]);
  if (response.status === 200) {
    yield call(setSnackBar, {
      payload: {
        message: 'Successful created customer.',
        open: true,
        type: 'success',
      },
    });
    yield call(movePage, { url: 'management/client', login: true });
  } else if (response.status === 409) {
    yield call(setSnackBar, {
      payload: {
        message: 'Already Exists Customer.',
        open: true,
        type: 'error',
      },
    });
  }
}

/**
 * [Management] 거래처 리스트 삭제
 */
export function* deleteClientList({ payload }) {
  let response = yield call(InvoiceApi.deleteClientList, payload.selectedList);
  if (response.status === 200) {
    if (payload.type === 'CLIENT') {
      // 삭제후 재조회
      const response = yield call(InvoiceApi.getClientList, payload.search);
      let clientList;
      if (response.status === 200) {
        clientList = response.data;
        yield put(Action.getClientList.success(clientList));
      }
    } else {
      let uploadClientList = yield select(
        (state) => state.reducer.uploadClientList
      );
      let uploadClientListNotCheck = uploadClientList.filter(
        (client) => client.selected === false
      );
      uploadClientList = uploadClientListNotCheck;
      yield put(Action.setUploadClientList.success(uploadClientList));
    }

    yield call(setSnackBar, {
      payload: {
        message: 'Successful deleted customer.',
        open: true,
        type: 'success',
      },
    });
  }
}

/**
 * [Management] 거래처 업로드 리스트 변경
 */
export function* setUploadClientList({ payload }) {
  yield put(Action.setUploadClientList.success(payload));
}

/**
 * [Management] 거래처 업로드 리스트 추가
 */
export function* insertUploadClientList({ payload }) {
  payload.data.map((x) => {
    x.tradeRegisteredName = x.tradeRegisteredName.trim();
  });
  let response = yield call(InvoiceApi.insertClientList, [...payload.data]);
  if (response.status === 200) {
    if (response.data.content) {
      yield put(Action.setUploadClientList.success(response.data.content));
      yield call(setSnackBar, {
        payload: {
          message: ` Added ${response.data.content.length} customer.`,
          open: true,
          type: 'success',
        },
      });
    } else {
      yield put(Action.setUploadClientList.success([]));
      yield call(setSnackBar, {
        payload: {
          message: `No additional customer.`,
          open: true,
          type: 'warning',
        },
      });
    }
  } else if (response.status === 409) {
    let duplicateList = [];
    response.data.content.forEach((trade) => {
      duplicateList.push(trade.tin);
    });
    yield call(setDialog, {
      payload: {
        open: true,
        title: 'TIN is dupplication.',
        message: [
          <div>
            <div>[ {duplicateList.join(', ')} ] </div>
            <div>Please check the TIN and upload it again. </div>
          </div>,
        ],

        closeLabel: 'confirm',
      },
    });
  }
}

/**
 * [Management] 거래처 상세보기 팝업 FLAG
 */
export function* isClientDetailPopup({ payload }) {
  yield put(Action.isClientDetailPopup.success(payload));
}

/**
 * [Management] 거래처 수정
 */
export function* updateClient({ payload }) {
  //tradeName 중복 체크 로직
  // if (
  //   // tradeName이 변경되었을경우 분기
  //   payload.tradeRegisteredName !== payload.detailInputs.tradeRegisteredName
  // ) {
  //   yield call(tradeRegisteredNameCheck, {
  //     tradeRegisteredName: payload.detailInputs.tradeRegisteredName,
  //   });

  //   let isTradeRegisteredName = yield select(
  //     (state) => state.reducer.checkElement.isTradeRegisteredName
  //   );
  //   if (!isTradeRegisteredName) {
  //     yield call(setSnackBar, {
  //       payload: {
  //         message: 'Fail(Trade Registered Name is duplicated)',
  //         open: true,
  //         type: 'error',
  //       },
  //     });
  //     return;
  //   }
  // }

  let response = yield call(InvoiceApi.updateClient, payload.detailInputs);
  if (response.status === 200) {
    yield call(setSnackBar, {
      payload: {
        message: 'Successful modified customer.',
        open: true,
        type: 'success',
      },
    });
    yield call(getClientList, { payload: payload.searchData });
    yield put(Action.isClientDetailPopup.success(false));
  } else {
    yield call(setSnackBar, {
      payload: {
        message: 'Failed to modify the customer.',
        open: true,
        type: 'error',
      },
    });
  }
}

// export function* itemNameCheck({ payload }) {
//   const response = yield call(InvoiceApi.itemNameCheck, payload);

//   yield put(Action.isItemNameCheck.success(response.data));

//   if (response.status === 200) {
//     if (response.data) {
//       yield call(setSnackBar, {
//         payload: {
//           message: 'SUCCESS(Name Check) ',
//           open: true,
//           type: 'success',
//         },
//       });
//     } else {
//       yield call(setSnackBar, {
//         payload: {
//           message: 'FAIL(Name duplication)',
//           open: true,
//           type: 'error',
//         },
//       });
//     }
//   }
// }

//거래처 TIN Check
export function* tradeTinCheck({ payload }) {
  payload.tin = payload.tin.replaceAll('-', '');
  const response = yield call(InvoiceApi.tradeTinCheck, payload);
  yield put(Action.tradeTinCheck.success(response.data));

  if (response.status === 200) {
    if (response.data) {
      yield call(setSnackBar, {
        payload: {
          message: 'SUCCESS(TIN Check) ',
          open: true,
          type: 'success',
        },
      });
    } else {
      yield call(setSnackBar, {
        payload: {
          message: 'FAIL(TIN dupplication)',
          open: true,
          type: 'error',
        },
      });
    }
  }
}

export function* tradeRegisteredNameCheck({ payload }) {
  const response = yield call(InvoiceApi.tradeRegisteredNameCheck, payload);
  yield put(Action.tradeRegisteredNameCheck.success(response.data));

  if (response.status === 200) {
    if (response.data) {
      yield call(setSnackBar, {
        payload: {
          message: 'SUCCESS(RegisteredName Check) ',
          open: true,
          type: 'success',
        },
      });
    } else {
      yield call(setSnackBar, {
        payload: {
          message: 'FAIL(RegisteredName duplication)',
          open: true,
          type: 'error',
        },
      });
    }
  }
}
export function* getClientStatus({ payload }) {
  let tin = payload.tin;

  payload?.branchCode
    ? payload.branchCode
    : (payload = { ...payload, branchCode: '00000' });

  payload = {
    ...payload,
    tin: tin.replaceAll('-', ''),
  };
  const response = yield call(InvoiceApi.tradeCloseCheck, payload);
  if (response.status == 200) {
    yield put(Action.getClientStatus.success(response.data[0]));
  } else if (response.status == 210) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Invalid TIN & Branch Code',
        closeLabel: 'confirm',
      },
    });
  }
}
/**
 * [Management] 품목 리스트 조회
 */
export function* getItemList({ payload }) {
  // yield call(setProgressBar, { payload: { open: true, message: '' } });
  const response = yield call(InvoiceApi.getItemList, payload);

  let itemList;
  if (response.status === 200) {
    itemList = response.data;
    yield put(Action.getItemList.success(itemList));
  }
}

/**
 * [Management] 품목 선택(selected) 리스트 변경
 */
export function* setItemList({ payload }) {
  yield put(Action.setItemList.success(payload));
}

/**
 * [Management] 품목 리스트 추가
 */
export function* insertItemList({ payload }) {
  payload = { ...payload, name: payload.name.trim() };
  //유효성 검사
  //NameCheck 유효성 검사 했는지 체크
  let itemNameCheck = yield select(
    (state) => state.reducer.checkElement.isItemName
  );

  //NameCheck false, null 이면 스낵바 보여줌
  if (!itemNameCheck) {
    yield call(setSnackBar, {
      payload: {
        message: 'Please Name Check',
        open: true,
        type: 'error',
      },
    });
    return;
  }

  let response = yield call(InvoiceApi.insertItemList, [payload]);
  if (response.status === 200) {
    yield call(setSnackBar, {
      payload: {
        message: 'Successful created item.',
        open: true,
        type: 'success',
      },
    });
    yield call(movePage, { url: 'management/item', login: true });
  } else if (response.status === 409) {
    yield call(setSnackBar, {
      payload: {
        message: 'Failed to create(name duplication)',
        open: true,
        type: 'error',
      },
    });
  }
}

/**
 * [Management] 품목 리스트 삭제
 */
export function* deleteItemList({ payload }) {
  // yield call(setProgressBar, { payload: { open: true, message: '' } });
  let response = yield call(InvoiceApi.deleteItemList, payload.selectedList);
  if (response.status === 200) {
    if (payload.type === 'ITEM') {
      const response = yield call(InvoiceApi.getItemList, payload.search);
      let itemList;
      if (response.status === 200) {
        itemList = response.data;
        yield put(Action.getItemList.success(itemList));
      }
    } else {
      let uploadItemList = yield select(
        (state) => state.reducer.uploadItemList
      );
      let uploadItemListNotCheck = uploadItemList.filter(
        (item) => item.selected === false
      );
      uploadItemList = uploadItemListNotCheck;
      yield put(Action.setUploadItemList.success(uploadItemList));
    }

    yield call(setSnackBar, {
      payload: {
        message: 'Successful deleted item.',
        open: true,
        type: 'success',
      },
    });
  }
}

export function* itemNameCheck({ payload }) {
  const response = yield call(InvoiceApi.itemNameCheck, payload);

  yield put(Action.isItemNameCheck.success(response.data));

  if (response.status === 200) {
    if (response.data) {
      yield call(setSnackBar, {
        payload: {
          message: 'SUCCESS(Name Check) ',
          open: true,
          type: 'success',
        },
      });
    } else {
      yield call(setSnackBar, {
        payload: {
          message: 'FAIL(Name duplication)',
          open: true,
          type: 'error',
        },
      });
    }
  }
}

/**
 * [Management] 품목 업로드 리스트 변경
 */
export function* setUploadItemList({ payload }) {
  yield put(Action.setUploadItemList.success(payload));
}

/**
 * [Management] 품목 업로드 리스트 추가
 */
export function* insertUploadItemList({ payload }) {
  // yield call(setProgressBar, { payload: { open: true, message: '' } });
  payload.data.map((x) => {
    x.name = x.name.trim();
  });
  let response = yield call(InvoiceApi.insertItemList, [...payload.data]);
  if (response.status === 200) {
    if (response.data.content) {
      yield put(Action.setUploadItemList.success(response.data.content));
      yield call(setSnackBar, {
        payload: {
          message: `Added ${response.data.content.length} item. `,
          open: true,
          type: 'success',
        },
      });
    } else {
      yield put(Action.setUploadItemList.success([]));
      yield call(setSnackBar, {
        payload: {
          message: `No additional items.`,
          open: true,
          type: 'warning',
        },
      });
    }
    // yield call(movePage, "management/client");
  } else if (response.status === 409) {
    let duplicateList = [];
    response.data.content.forEach((item) => {
      duplicateList.push(item.name);
    });
    yield call(setDialog, {
      payload: {
        open: true,
        title: 'Item name & Description is dupplication.',
        message: [
          <div>
            <div> {duplicateList.join(', ')} </div>
            <div>Duplicate check Item name & Description. </div>
          </div>,
        ],

        closeLabel: 'confirm',
      },
    });
  }
}

/**
 * [Management] 품목 상세보기 팝업 FLAG
 */
export function* isItemDetailPopup({ payload }) {
  yield put(Action.isItemDetailPopup.success(payload));
}

/**
 * [Management] 품목 수정
 */
export function* updateItem({ payload }) {
  let response = yield call(InvoiceApi.updateItem, payload.detailInputs);
  if (response.status === 200) {
    yield call(setSnackBar, {
      payload: {
        message: 'Successful modified item',
        open: true,
        type: 'success',
      },
    });
    yield call(getItemList, { payload: payload.searchData });
    yield put(Action.isItemDetailPopup.success(false));
  } else if (response.status === 409) {
    yield call(setSnackBar, {
      payload: {
        message: 'Failed to update(name duplication)',
        open: true,
        type: 'error',
      },
    });
  }
}

export default [
  takeLatest(Action.getClientList.TRIGGER, taker(getClientList)),
  takeLatest(Action.setClientList.TRIGGER, taker(setClientList)),
  takeLatest(Action.insertClientList.TRIGGER, taker(insertClientList)),
  takeLatest(Action.deleteClientList.TRIGGER, taker(deleteClientList)),
  takeLatest(Action.setUploadClientList.TRIGGER, taker(setUploadClientList)),
  takeLatest(Action.isClientDetailPopup.TRIGGER, taker(isClientDetailPopup)),
  takeLatest(
    Action.insertUploadClientList.TRIGGER,
    taker(insertUploadClientList)
  ),
  takeLatest(Action.updateClient.TRIGGER, taker(updateClient)),
  takeLatest(Action.getClientStatus.TRIGGER, taker(getClientStatus)),
  takeLatest(Action.tradeTinCheck.TRIGGER, taker(tradeTinCheck)),
  takeLatest(
    Action.tradeRegisteredNameCheck.TRIGGER,
    taker(tradeRegisteredNameCheck)
  ),

  takeLatest(Action.getItemList.TRIGGER, taker(getItemList)),
  takeLatest(Action.setItemList.TRIGGER, taker(setItemList)),
  takeLatest(Action.insertItemList.TRIGGER, taker(insertItemList)),
  takeLatest(Action.deleteItemList.TRIGGER, taker(deleteItemList)),
  takeLatest(Action.setUploadItemList.TRIGGER, taker(setUploadItemList)),
  takeLatest(Action.isItemDetailPopup.TRIGGER, taker(isItemDetailPopup)),
  takeLatest(Action.insertUploadItemList.TRIGGER, taker(insertUploadItemList)),
  takeLatest(Action.updateItem.TRIGGER, taker(updateItem)),
  takeLatest(Action.itemNameCheck.TRIGGER, taker(itemNameCheck)),
];
